module.exports = __webpack_public_path__ + "img/address_list.918008cf.png";